export const CONTEXT_ATTRS_PREFIX = 'context_attributes_json.';
export const DATA_JSON_PREFIX = 'data_json.';

/** Synthetic scope field — never persisted; dropped by filterTokenToLeaf. */
export const CONTEXT_KIND_FIELD = 'context';
